module.exports = __webpack_public_path__ + "img/14.e9977e9.jpg";